export type Actions = {
  enabled: ComplianceActionTypes[];
};

export const ComplianceActionTypes = {
  GAMEPLAY: 'gameplay',
  DEPOSIT: 'deposit',
  WITHDRAWAL: 'withdrawal',
  INCENTIVE: 'incentive',
} as const;

export type ComplianceActionTypes = (typeof ComplianceActionTypes)[keyof typeof ComplianceActionTypes];

export const UserStates = {
  FETCHING: 'fetching',
  LOGGED_OUT: 'logged-out',
  LOGGED_IN: 'logged-in',
  SHOWING_STATS_REQUIRED: 'showing-stats-required',
  ACTIVATED: 'activated',
  COOL_OFF: 'cool-off',
  REALITY_CHECK_REQUIRED: 'reality-check-required',
  REALITY_CHECK: 'reality-check',
  LONG_PLAY: 'long-play',
  NIGHT_PLAY: 'night-play',
  OASIS_SUSPENDED: 'oasis-suspended',
  OASIS_ERROR: 'oasis-error',
  DEACTIVATED: 'deactivated',
  LIMITED_MODE: 'limited-mode',
  ACTIVATION_FAILED: 'activation-failed',
  ACTIVATION_COOL_OFF: 'activation-cool-off',
  FAILURE: 'failure',
  IDLE: 'idle',
} as const;

export type UserStates = (typeof UserStates)[keyof typeof UserStates];

export type UserState = {
  state: UserStates;
  actions: Actions;
};
